import React, { useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    Tabs,
    Tab,
    Button,
    Grid,
    Card,
    CardContent,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    Divider,
    IconButton
} from '@mui/material';
import {
    AddCircleOutline as AddIcon,
    Assignment as ReportIcon,
    CheckCircle as AcceptedIcon,
    Cancel as RejectedIcon,
    Send as SentIcon,
    Business as BrandIcon
} from '@mui/icons-material';

const InformacionComercial = () => {
    const [tabValue, setTabValue] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [formData, setFormData] = useState({
        marca: '',
        tipoSolicitud: '',
        comentarios: ''
    });

    // Mock data for brands
    const mockBrands = [
        { id: 1, nombre: 'Mezcal Real', status: 'Aceptada', fecha: '2024-03-01' },
        { id: 2, nombre: 'Alma de Maguey', status: 'Enviada', fecha: '2024-03-05' },
        { id: 3, nombre: 'Destilado Sagrado', status: 'Rechazada', fecha: '2024-02-28' },
        { id: 4, nombre: 'Esencia Purepecha', status: 'Aceptada', fecha: '2024-03-02' },
        { id: 5, nombre: 'Viento del Sur', status: 'Enviada', fecha: '2024-03-08' },
    ];

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = () => {
        alert('Solicitud enviada correctamente (Simulación)');
        handleCloseModal();
    };

    const filteredBrands = mockBrands.filter(brand => {
        if (tabValue === 0) return brand.status === 'Enviada';
        if (tabValue === 1) return brand.status === 'Rechazada';
        if (tabValue === 2) return brand.status === 'Aceptada';
        return true;
    });

    const getStatusIcon = (status) => {
        switch (status) {
            case 'Aceptada': return <AcceptedIcon color="success" />;
            case 'Rechazada': return <RejectedIcon color="error" />;
            case 'Enviada': return <SentIcon color="primary" />;
            default: return null;
        }
    };

    return (
        <div className='container2'>
            <Box sx={{ p: 4, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
                <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2b2b2b' }}>
                            Información Comercial
                        </Typography>
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={handleOpenModal}
                            sx={{
                                backgroundColor: '#c88b3e',
                                '&:hover': { backgroundColor: '#a67332' },
                                borderRadius: '20px',
                                px: 3
                            }}
                        >
                            Solicitar Informe
                        </Button>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        sx={{
                            mb: 3,
                            '& .MuiTabs-indicator': { backgroundColor: '#c88b3e' },
                            '& .Mui-selected': { color: '#c88b3e !important' }
                        }}
                    >
                        <Tab label="Enviadas" />
                        <Tab label="Rechazadas" />
                        <Tab label="Aceptadas" />
                    </Tabs>

                    <Grid container spacing={3}>
                        {filteredBrands.length > 0 ? (
                            filteredBrands.map((brand) => (
                                <Grid item xs={12} sm={6} md={4} key={brand.id}>
                                    <Card sx={{
                                        borderRadius: 2,
                                        borderLeft: `5px solid ${brand.status === 'Aceptada' ? '#4caf50' : brand.status === 'Rechazada' ? '#f44336' : '#2196f3'}`,
                                        transition: 'transform 0.2s',
                                        '&:hover': { transform: 'scale(1.02)' }
                                    }}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                                <BrandIcon sx={{ color: '#c88b3e', fontSize: 40 }} />
                                                {getStatusIcon(brand.status)}
                                            </Box>
                                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                {brand.nombre}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                Fecha: {brand.fecha}
                                            </Typography>
                                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                                <Chip
                                                    label={brand.status}
                                                    size="small"
                                                    variant="outlined"
                                                    sx={{
                                                        color: brand.status === 'Aceptada' ? '#4caf50' : brand.status === 'Rechazada' ? '#f44336' : '#2196f3',
                                                        borderColor: brand.status === 'Aceptada' ? '#4caf50' : brand.status === 'Rechazada' ? '#f44336' : '#2196f3'
                                                    }}
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))
                        ) : (
                            <Grid item xs={12}>
                                <Box sx={{ textAlign: 'center', py: 5 }}>
                                    <Typography variant="h6" color="textSecondary">
                                        No hay registros en esta categoría.
                                    </Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </Paper>

                {/* Modal para solicitar informe */}
                <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
                    <DialogTitle sx={{ backgroundColor: '#2b2b2b', color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <ReportIcon /> Solicitar Informe Comercial
                    </DialogTitle>
                    <DialogContent sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Seleccionar Marca"
                                    name="marca"
                                    value={formData.marca}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    sx={{ mt: 1 }}
                                >
                                    {mockBrands.map((brand) => (
                                        <MenuItem key={brand.id} value={brand.nombre}>
                                            {brand.nombre}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Tipo de Informe"
                                    name="tipoSolicitud"
                                    value={formData.tipoSolicitud}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                >
                                    <MenuItem value="Nacional">Mercado Nacional</MenuItem>
                                    <MenuItem value="Exportacion">Exportación</MenuItem>
                                    <MenuItem value="Certificacion">Certificación de Marca</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={4}
                                    label="Comentarios o Datos Adicionales"
                                    name="comentarios"
                                    value={formData.comentarios}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions sx={{ p: 3 }}>
                        <Button onClick={handleCloseModal} sx={{ color: '#2b2b2b' }}>
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                            sx={{
                                backgroundColor: '#c88b3e',
                                '&:hover': { backgroundColor: '#a67332' }
                            }}
                        >
                            Enviar Solicitud
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </div>
    );
};

export default InformacionComercial;
